import { render, staticRenderFns } from "./payment-detail.vue?vue&type=template&id=40dcb6b6&scoped=true"
import script from "./payment-detail.vue?vue&type=script&lang=js"
export * from "./payment-detail.vue?vue&type=script&lang=js"
import style0 from "./payment-detail.vue?vue&type=style&index=0&id=40dcb6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dcb6b6",
  null
  
)

export default component.exports